import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { ClientPresentationState } from '../account/my-account/model/ui-state/ClientPresentationState';

export interface GpState {
  uiPrefs: ClientPresentationState;
}

export interface LpState { }

export interface AppState {
  gp: GpState;
  lp: LpState;
}

export function createInitialState(): AppState {
  return {
    gp: {
      uiPrefs: new ClientPresentationState(),
    } as GpState,
    lp: {} as LpState
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'app' })
export class AppStore extends Store<AppState> {

  constructor() {
    super(createInitialState());
  }
}
